import React from 'react';
import { Form, Input, Row, Col, Checkbox, Button, message, Spin } from 'antd';
import {StyledSubscriptionCard} from './style';
import ApiService from '../../actions/apiService';
import { getCountries } from '../../actions/posts';
import ReactFlagsSelect from 'react-flags-select';
import 'react-flags-select/css/react-flags-select.css';

const FormItem = Form.Item;
class TradeAlertForm extends React.Component {
  
  state = {
    isLoading: true,
    error: '',
    success: '',
    isNotification: false,
    countryList: [],
    profileData: {}
  }
  
  async componentWillMount() {
    this.bindCountries();
    const profileData = await ApiService.getProfile();
    this.setState({
      isLoading: false,
      profileData: profileData || {}
    }, () => {
      if (profileData) {
        this.props.form.setFieldsValue({
          cellPhoneForText: profileData.cellPhoneForText,
          tradeAlerts: profileData.tradeAlerts,
          isNotification: !!profileData.cellPhoneForText,
          weeklySchedule: profileData.weeklySchedule,
          sessionStarting: profileData.sessionStarting,
          sessionRecordingReady: profileData.sessionRecordingReady,
        })
        this.setState({
          countryCode: profileData.CellPhoneCountryCodeForText
        })
      }
    })
  }
  
  bindCountries = async () => {
    const response = await getCountries();
    if (response) {
      this.setState({
        countryList: (response.data && response.data.data && response.data.data.countries) || [],
      });
    }
  }
  
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const data = {
          ...this.state.profileData,
          cellPhoneForText: values.cellPhoneForText,
          tradeAlerts: values.tradeAlerts,
          weeklySchedule: values.weeklySchedule,
          sessionStarting: values.sessionStarting,
          sessionRecordingReady: values.sessionRecordingReady,
          CellPhoneCountryCodeForText : this.state.countryCode,
        }
        const profileData = await ApiService.postProfile(data);
        if (profileData && profileData.status === 200) {
          message.success('Alert saved successfully!');
        } else {
          message.error('Something went wrong!');
        }
      }
    })
  }
  
  testAlert = () => {
    this.props.form.validateFields(async (err, values) => {
      if (!err) {
        const resp = await ApiService.testSMS(values.cellphoneAlerts);
        if (resp) {
          message.success('Message sent successfully!');
        }
        else {
          message.error('Something went wrong');
        }
      }
    })
  }
  
  onSelectFlag = (countryCode) => {
    this.setState({
      countryCode,
    });
    
  }
  
  onChange = (e) => {
    if (!e.target.checked) {
      this.props.form.setFieldsValue({
        cellPhoneForText: ''
      });
    }
  }
  
  render() {
    const { getFieldDecorator } = this.props.form;
    const { countryList = [], countryCode } = this.state;
    if (this.state.isLoading) {
      return (
        <div style={{textAlign: 'center', marginTop: 50, width: '100%'}}>
          <Spin/>
        </div>
      );
    }
    const isNotification = this.props.form.getFieldValue('isNotification')
    const countryLabels = {};
    countryList.forEach(x => {
      if (x.countrycode && x.countryname) {
        countryLabels[x.countrycode] = x.countryname;
      }
    })
    let phoneCode = '';
    if (countryCode && countryList.length) {
      const code = countryList.find(x => x.countrycode === countryCode);
      phoneCode= (code && code.phonecode) || '';
    }
    return (
     <Row gutter={16} style={{minHeight: '50vh'}}>
            <Col span={16}>
              <Form layout={'vertical'} onSubmit={this.handleSubmit}>
                <Row gutter={16}>
                  <Col sm={24} xs={24}>
                    <FormItem>
                      {getFieldDecorator('isNotification', {
                        valuePropName: 'checked',
                        defaultValue: false,
                      })(
                        <Checkbox name="isNotification" onChange={this.onChange}>Enable Text Message Notifications</Checkbox>
                      )}
                    </FormItem>
                  </Col>
                </Row>
                  <Row gutter={16} style={!isNotification ? {display: 'none'} : {}}>
                    <Col sm={10} xs={24}>
                      <FormItem label="Select your country">
                        <ReactFlagsSelect
                          searchable
                          countries={countryList.filter(x=>x.countrycode && x.countryname).map(x => x.countrycode)}
                          customLabels={countryLabels}
                          defaultCountry={this.state.countryCode || ''}
                          onSelect={this.onSelectFlag} />
                      </FormItem>
                    </Col>
                    <Col sm={10} xs={24} className="alert-phone">
                      <FormItem label="Cell Phone for Text Alerts">
                        {getFieldDecorator('cellPhoneForText', {
                          rules: [{
                            required: isNotification,
                            message: 'Please input your first name!',
                            whitespace: true
                          }],
                        })(
                          <Input placeholder="Input cell phone number" prefix={<div>{phoneCode}</div>}/>
                        )}
                      </FormItem>
                    </Col>
                    <Col sm={4}>
                      <div className="ant-form-item-label"><label>&nbsp;</label></div>
                      <div className="ant-form-item-control-wrapper">
                        <div className="ant-form-item-control">
                          <Button onClick={this.testAlert}>Test</Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                <Row>
                  <Col sm={24} xs={24}>
                    <StyledSubscriptionCard title="Email Group">
                      <FormItem>
                        {getFieldDecorator('tradeAlerts', {
                          valuePropName: 'checked',
                          defaultValue: false,
                        })(
                          <Checkbox>Trade Alerts</Checkbox>
                        )}
                      </FormItem>
                      <FormItem>
                        {getFieldDecorator('weeklySchedule', {
                          valuePropName: 'checked',
                          defaultValue: false,
                        })(
                          <Checkbox>Weekly Schedule</Checkbox>
                        )}
                      </FormItem>
                      <FormItem>
                        {getFieldDecorator('sessionStarting', {
                          valuePropName: 'checked',
                          defaultValue: false,
                        })(
                          <Checkbox>Session Starting</Checkbox>
                        )}
                      </FormItem>
                      <FormItem>
                        {getFieldDecorator('sessionRecordingReady', {
                          valuePropName: 'checked',
                          defaultValue: false,
                        })(
                          <Checkbox>Session Recording Ready</Checkbox>
                        )}
                      </FormItem>
                    </StyledSubscriptionCard>
                    
                </Col>
                </Row>
                <Row gutter={16}>
                  <Col sm={24} style={{textAlign: 'right'}}>
                    <button type="submit" style={{width: '200px', background: '#3190ff', color: '#fff'}} className="ant-btn ant-btn-submit">Save</button>
                  </Col>
                </Row>
              </Form>
            
            </Col>
          </Row>
    );
  }
}

const TradeAlert = Form.create()(TradeAlertForm);
export default TradeAlert



// WEBPACK FOOTER //
// ./src/components/user-profile/TradeAlerts.js